import posts from './posts';
import titles from './titles';
import { combineReducers } from "redux";

export default combineReducers({
  posts,
  titles,
});